import { render, staticRenderFns } from "./EmailList.vue?vue&type=template&id=f73bf8ea&scoped=true"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"
import style0 from "./EmailList.vue?vue&type=style&index=0&id=f73bf8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73bf8ea",
  null
  
)

export default component.exports